/** @jsx jsx */
import { jsx, css } from "@emotion/core";

function CivicHeaderImage() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      version="1.1"
      viewBox="0 0 370.8 370.8"
      xmlSpace="preserve"
      css={css`
        .st0 {
          fill: #fbad2b;
        }

        .st1 {
          fill: #ed3555;
        }

        .st2 {
          fill: #1fbaab;
        }

        .st3 {
          fill: #2965b0;
        }

        .st4 {
          fill: #7a287e;
        }

        .st5 {
          fill: #fff;
        }
        max-width: 350px;
        height: 100%;
        z-index: -1;
        margin-right: -200px;
      `}
    >
      <path
        d="M353.3 215c1.7-9.8 2.6-19.7 2.6-29.6 2.5 2.5 5.1 5.1 7.6 7.8 1.3 1.4 2.5 2.7 3.7 4.1 1.2 1.4 2.4 2.8 3.6 4.3-2.7 2.5-5.7 4.8-8.6 7.1-1.4 1.1-2.9 2.2-4.3 3.3-1.6 1-3.1 2-4.6 3z"
        className="st0"
      />
      <path
        d="M345.7 243.7c3.4-9.3 5.9-18.9 7.6-28.7 2.1 2.9 4.3 5.9 6.2 9 1 1.5 1.9 3.1 2.9 4.7s1.9 3.2 2.8 4.9c-3.3 1.9-6.4 3.8-9.7 5.5-3.3 1.6-6.6 3.2-9.8 4.6z"
        className="st1"
      />
      <path
        d="M333.1 270.6c5-8.6 9.2-17.6 12.6-26.9 1.6 3.2 3 6.5 4.5 9.9 1.4 3.4 2.6 6.8 3.9 10.4l-2.6 1c-.9.3-1.8.6-2.6.9-1.8.6-3.5 1.2-5.3 1.7-3.5 1.3-7 2.2-10.5 3z"
        className="st2"
      />
      <path
        d="M316 295c6.4-7.6 12.1-15.8 17-24.3.5 1.7 1 3.5 1.5 5.2.4 1.7.8 3.5 1.2 5.3.4 1.8.8 3.6 1.1 5.4.4 1.8.6 3.6.9 5.5-7.2 1.5-14.5 2.4-21.7 2.9z"
        className="st3"
      />
      <path
        d="M315.2 297.7c.2 2.7.5 5.5.6 8.3.1 3.3.2 6.7.1 10h-1.4c-2.9 0-5.8 0-8.6-.1s-5.6-.3-8.3-.6l.1-.1c1.2-1 2.4-2.1 3.6-3.1l5.4-5.1 5.1-5.4c1.1-1.2 2.1-2.4 3.1-3.6.2-.3.2-.3.3-.3m.8-2.7c-1.6 1.9-3.2 3.8-4.9 5.6L306 306l-5.4 5.1c-1.8 1.7-3.7 3.3-5.6 4.9 3.5.3 7.2.7 10.9.8 2.8.1 5.7.1 8.7.1h2.5c0-3.8 0-7.5-.1-11.1-.3-3.6-.6-7.3-1-10.8z"
        className="st4"
      />
      <path
        d="M270.6 333.1c8.6-5 16.7-10.7 24.3-17-.5 7.1-1.4 14.5-2.9 21.8-1.9-.3-3.7-.5-5.5-.9-1.8-.4-3.6-.7-5.4-1.1-1.8-.4-3.6-.8-5.3-1.2-1.7-.6-3.4-1.1-5.2-1.6z"
        className="st0"
      />
      <path
        d="M243.7 345.7c9.3-3.4 18.3-7.6 26.9-12.6-.8 3.5-1.8 7-2.9 10.5-1.1 3.5-2.3 7.1-3.7 10.5-3.6-1.3-7-2.5-10.4-3.9-3.4-1.5-6.7-2.9-9.9-4.5z"
        className="st1"
      />
      <path
        d="M215 353.3c9.8-1.7 19.4-4.2 28.7-7.6-1.5 3.2-3 6.5-4.7 9.8-1.7 3.2-3.5 6.4-5.5 9.7-1.6-.9-3.3-1.8-4.9-2.8-1.6-1-3.2-1.9-4.7-2.9-3-1.9-6-4.1-8.9-6.2z"
        className="st5"
      />
      <path
        d="M185.4 356c9.9 0 19.8-.9 29.6-2.6-1 1.5-2 3-3.1 4.5-1.1 1.4-2.2 2.9-3.3 4.3-2.2 2.9-4.6 5.9-7.1 8.6-1.5-1.2-2.9-2.4-4.3-3.6-1.4-1.2-2.8-2.4-4.1-3.7-2.6-2.5-5.2-5-7.7-7.5z"
        className="st3"
      />
      <path
        d="M158.1 354.8c8.1 1.3 16.4 2 24.7 2.2-1.9 1.9-3.9 3.8-5.9 5.7-1.3 1.2-2.6 2.4-4 3.5l-.1.1c-1.1 1-2.3 1.9-3.5 2.9-2.3-2.6-4.4-5.3-6.3-7.8-1.1-1.4-2.2-2.9-3.2-4.3-.6-.7-1.2-1.5-1.7-2.3m-2.3-1.5c1 1.5 2 3 3.1 4.5 1.1 1.4 2.2 2.9 3.3 4.3 2.2 2.9 4.6 5.9 7.1 8.6 1.5-1.2 2.9-2.4 4.3-3.6 1.4-1.2 2.8-2.4 4.1-3.7 2.7-2.5 5.3-5.1 7.8-7.6-10.1.1-20-.8-29.7-2.5z"
        className="st4"
      />
      <path
        d="M127 345.7c9.3 3.4 18.9 5.9 28.7 7.6-2.9 2.1-5.9 4.3-9 6.2-1.5 1-3.1 1.9-4.7 2.9s-3.2 1.9-4.9 2.8c-1.9-3.3-3.8-6.4-5.5-9.7-1.5-3.3-3.1-6.6-4.6-9.8z"
        className="st0"
      />
      <path
        d="M100.1 333.1c8.6 5 17.6 9.2 26.9 12.6-3.2 1.6-6.5 3-9.9 4.5-3.4 1.4-6.8 2.6-10.4 3.9l-1-2.6c-.3-.9-.6-1.8-.9-2.6-.6-1.8-1.2-3.5-1.7-5.3-1.2-3.5-2.1-7-3-10.5z"
        className="st1"
      />
      <path
        d="M75.8 316c7.6 6.4 15.8 12.1 24.3 17-1.7.5-3.5 1-5.2 1.5-1.7.4-3.5.8-5.3 1.2-1.8.4-3.6.8-5.4 1.1-1.8.4-3.6.6-5.5.9-1.5-7.2-2.5-14.5-2.9-21.7z"
        className="st2"
      />
      <path
        d="M55.6 297.6l.1.1c1 1.2 2.1 2.4 3.1 3.6l5.1 5.4 5.4 5.1c1.2 1.1 2.4 2.1 3.6 3.1l.1.1c-2.7.2-5.5.5-8.3.6-2.8.1-5.7.1-8.6.1h-1.4c0-3.4 0-6.7.1-10 .3-2.6.5-5.4.8-8.1m-.9-2.6c-.3 3.5-.7 7.2-.8 10.9-.1 3.6-.2 7.3-.1 11.1h2.5c2.9 0 5.8 0 8.6-.1 3.7-.2 7.3-.5 10.9-.8-1.9-1.6-3.8-3.2-5.6-4.9l-5.4-5.1-5.1-5.4c-1.7-1.9-3.3-3.8-5-5.7z"
        className="st3"
      />
      <path
        d="M37.7 270.6c5 8.6 10.7 16.7 17 24.3-7.1-.5-14.5-1.4-21.8-2.9.3-1.9.5-3.7.9-5.5.4-1.8.7-3.6 1.1-5.4.4-1.8.8-3.6 1.2-5.3.6-1.7 1.1-3.4 1.6-5.2z"
        className="st4"
      />
      <path
        d="M25.1 243.7c3.4 9.3 7.6 18.3 12.6 26.9-3.5-.8-7-1.8-10.5-2.9-3.5-1.1-7.1-2.3-10.5-3.7 1.3-3.6 2.5-7 3.9-10.4 1.4-3.4 2.9-6.7 4.5-9.9z"
        className="st0"
      />
      <path
        d="M17.4 215c1.7 9.8 4.2 19.4 7.6 28.7-3.2-1.5-6.5-3-9.8-4.7-3.2-1.7-6.4-3.5-9.7-5.5.9-1.6 1.8-3.3 2.8-4.9 1-1.6 1.9-3.2 2.9-4.7 2-3 4.1-6 6.2-8.9z"
        className="st1"
      />
      <path
        d="M14.8 185.4c0 9.9.9 19.8 2.6 29.6-1.5-1-3-2-4.5-3.1-1.4-1.1-2.9-2.2-4.3-3.3-2.9-2.2-5.9-4.6-8.6-7.1 1.2-1.5 2.4-2.9 3.6-4.3 1.2-1.4 2.4-2.8 3.7-4.1 2.5-2.6 5-5.2 7.5-7.7z"
        className="st2"
      />
      <path
        d="M17.4 155.8c-1.7 9.8-2.6 19.7-2.6 29.6-2.5-2.5-5.1-5.1-7.6-7.8-1.3-1.4-2.5-2.7-3.7-4.1-1.2-1.4-2.4-2.8-3.6-4.3 2.7-2.5 5.7-4.8 8.6-7.1 1.4-1.1 2.9-2.2 4.3-3.3 1.6-1 3.1-2 4.6-3z"
        className="st3"
      />
      <path
        d="M25.1 127c-3.4 9.3-5.9 18.9-7.6 28.7-2.1-2.9-4.3-5.9-6.2-9-1-1.5-1.9-3.1-2.9-4.7s-1.9-3.2-2.8-4.9c3.3-1.9 6.4-3.8 9.7-5.5 3.3-1.5 6.5-3.1 9.8-4.6z"
        className="st4"
      />
      <path
        d="M37.7 100.1c-5 8.6-9.2 17.6-12.6 26.9-1.6-3.2-3-6.5-4.5-9.9-1.4-3.4-2.6-6.8-3.9-10.4l2.6-1c.9-.3 1.8-.6 2.6-.9 1.8-.6 3.5-1.2 5.3-1.7 3.4-1.2 7-2.1 10.5-3z"
        className="st0"
      />
      <path
        d="M54.7 75.8c-6.4 7.6-12.1 15.8-17 24.3-.5-1.7-1-3.5-1.5-5.2-.4-1.7-.8-3.5-1.2-5.3-.4-1.8-.8-3.6-1.1-5.4-.4-1.8-.6-3.6-.9-5.5 7.3-1.5 14.6-2.5 21.7-2.9z"
        className="st1"
      />
      <path
        d="M56.2 54.8c2.9 0 5.8 0 8.6.1s5.6.3 8.3.6l-.1.1c-1.2 1-2.4 2.1-3.6 3.1L64 64l-5.1 5.4c-1.1 1.2-2.1 2.4-3.1 3.6l-.1.1c-.2-2.7-.5-5.5-.6-8.3-.1-3.3-.2-6.7-.1-10h1.2m0-1h-2.5c0 3.8 0 7.5.1 11.1.2 3.7.5 7.3.8 10.9 1.6-1.9 3.2-3.8 4.9-5.6l5.1-5.4 5.4-5.1c1.8-1.7 3.7-3.3 5.6-4.9-3.5-.3-7.2-.7-10.9-.8-2.6-.2-5.5-.2-8.5-.2z"
        className="st2"
      />
      <path
        d="M100.1 37.7c-8.6 5-16.7 10.7-24.3 17 .5-7.1 1.4-14.5 2.9-21.8 1.9.3 3.7.5 5.5.9 1.8.4 3.6.7 5.4 1.1 1.8.4 3.6.8 5.3 1.2 1.7.6 3.5 1.1 5.2 1.6z"
        className="st3"
      />
      <path
        d="M127 25.1c-9.3 3.4-18.3 7.6-26.9 12.6.8-3.5 1.8-7 2.9-10.5 1.1-3.5 2.3-7.1 3.7-10.5 3.6 1.3 7 2.5 10.4 3.9 3.4 1.4 6.7 2.9 9.9 4.5z"
        className="st4"
      />
      <path
        d="M155.8 17.4c-9.8 1.7-19.4 4.2-28.7 7.6 1.5-3.2 3-6.5 4.7-9.8 1.7-3.2 3.5-6.4 5.5-9.7 1.6.9 3.3 1.8 4.9 2.8 1.6 1 3.2 1.9 4.7 2.9 3 2 6 4.1 8.9 6.2z"
        className="st2"
      />
      <path
        d="M185.4 14.8c-9.9 0-19.8.9-29.6 2.6 1-1.5 2-3 3.1-4.5 1.1-1.4 2.2-2.9 3.3-4.3 2.2-2.9 4.6-5.9 7.1-8.6 1.5 1.2 2.9 2.4 4.3 3.6 1.4 1.2 2.8 2.4 4.1 3.7 2.6 2.5 5.2 5 7.7 7.5z"
        className="st5"
      />
      <path
        d="M233.2 7c1.6 2.8 3.3 5.7 4.9 8.7 1.2 2.5 2.5 4.9 3.6 7.4-7.7-2.7-15.7-4.8-23.9-6.4 2.1-1.5 4.5-3.2 6.9-4.6 1.5-1 3.1-1.9 4.7-2.9 1.4-.8 2.6-1.5 3.8-2.2m.4-1.4c-1.6.9-3.3 1.8-4.9 2.8-1.6 1-3.2 1.9-4.7 2.9-3.1 1.9-6.1 4-9 6.2 9.8 1.7 19.4 4.2 28.7 7.6-1.5-3.2-3-6.5-4.7-9.8-1.7-3.3-3.5-6.5-5.4-9.7z"
        className="st2"
      />
      <path
        d="M270.6 37.7c-8.6-5-17.6-9.2-26.9-12.6 3.2-1.6 6.5-3 9.9-4.5 3.4-1.4 6.8-2.6 10.4-3.9l1 2.6c.3.9.6 1.8.9 2.6.6 1.8 1.2 3.5 1.7 5.3 1.3 3.4 2.2 7 3 10.5z"
        className="st3"
      />
      <path
        d="M295 54.7c-7.6-6.4-15.8-12.1-24.3-17 1.7-.5 3.5-1 5.2-1.5 1.7-.4 3.5-.8 5.3-1.2 1.8-.4 3.6-.8 5.4-1.1 1.8-.4 3.6-.6 5.5-.9 1.5 7.3 2.4 14.6 2.9 21.7z"
        className="st4"
      />
      <path
        d="M316 75.8c-1.6-1.9-3.2-3.8-4.9-5.6l-5.1-5.4-5.4-5.1c-1.8-1.7-3.7-3.3-5.6-4.9 3.5-.3 7.2-.7 10.9-.8 3.6-.1 7.3-.2 11.1-.1 0 3.8 0 7.5-.1 11.1-.2 3.6-.5 7.2-.9 10.8z"
        className="st0"
      />
      <path
        d="M333.1 100.1c-5-8.6-10.7-16.7-17-24.3 7.1.5 14.5 1.4 21.8 2.9-.3 1.9-.5 3.7-.9 5.5-.4 1.8-.7 3.6-1.1 5.4-.4 1.8-.8 3.6-1.2 5.3-.6 1.7-1.1 3.5-1.6 5.2z"
        className="st1"
      />
      <path
        d="M345.7 127c-3.4-9.3-7.6-18.3-12.6-26.9 3.5.8 7 1.8 10.5 2.9 3.5 1.1 7.1 2.3 10.5 3.7-1.3 3.6-2.5 7-3.9 10.4-1.5 3.4-2.9 6.7-4.5 9.9z"
        className="st2"
      />
      <path
        d="M353.3 155.8c-1.7-9.8-4.2-19.4-7.6-28.7 3.2 1.5 6.5 3 9.8 4.7 3.2 1.7 6.4 3.5 9.7 5.5-.9 1.6-1.8 3.3-2.8 4.9-1 1.6-1.9 3.2-2.9 4.7-1.9 3-4.1 6-6.2 8.9z"
        className="st3"
      />
      <path
        d="M356 185.4c0-9.9-.9-19.8-2.6-29.6 1.5 1 3 2 4.5 3.1 1.4 1.1 2.9 2.2 4.3 3.3 2.9 2.2 5.9 4.6 8.6 7.1-1.2 1.5-2.4 2.9-3.6 4.3-1.2 1.4-2.4 2.8-3.7 4.1-2.5 2.6-5 5.2-7.5 7.7z"
        className="st5"
      />
      <path
        d="M331.6 214c1.8-9.3 2.8-18.8 2.8-28.3 2.4 2.4 4.9 4.9 7.3 7.5 2.3 2.6 4.6 5.3 6.9 8.2-2.8 2.4-5.6 4.6-8.4 6.7-2.9 2.1-5.8 4.1-8.6 5.9z"
        className="st0"
      />
      <path
        d="M323.2 242c3.6-8.8 6.4-17.9 8.3-27.2 1.9 2.8 3.8 5.7 5.7 8.8 1.8 3 3.5 6.1 5.2 9.4-3.1 1.8-6.4 3.4-9.5 4.9-3.3 1.5-6.6 2.8-9.7 4.1z"
        className="st1"
      />
      <path
        d="M309.5 267.8c5.3-7.9 9.8-16.3 13.4-25.1 1.4 3.1 2.6 6.4 3.9 9.7 1.2 3.3 2.2 6.7 3.2 10.2-3.4 1.1-6.9 2.1-10.3 3-3.4.9-6.9 1.5-10.2 2.2z"
        className="st2"
      />
      <path
        d="M308.5 271.2c.5 2.6 1 5.2 1.4 7.7.4 3.2.8 6.4 1.1 9.5-3.2.3-6.4.6-9.5.8-2.6.1-5.3.2-7.8.2 5.3-5.7 10.3-11.8 14.8-18.2m.6-2.8c-5.3 7.9-11.4 15.3-18.1 22h2c2.8 0 5.6-.1 8.4-.2 3.5-.2 7-.5 10.7-.9-.3-3.6-.7-7.2-1.2-10.6-.5-3.5-1.1-7-1.8-10.3z"
        className="st3"
      />
      <path
        d="M268.5 309c7.9-5.3 15.2-11.4 22-18.1 0 3.4 0 6.9-.1 10.5-.2 3.5-.5 7.1-.9 10.7-3.6-.3-7.2-.7-10.6-1.2-3.7-.6-7.1-1.2-10.4-1.9z"
        className="st4"
      />
      <path
        d="M242.8 322.9c8.8-3.7 17.2-8.2 25.1-13.4-.3 1.7-.6 3.4-1 5.1-.4 1.7-.7 3.5-1.2 5.1-.9 3.4-1.8 6.9-3 10.3-3.5-1-6.9-2-10.2-3.2-3.4-1.3-6.6-2.5-9.7-3.9z"
        className="st0"
      />
      <path
        d="M240.1 325.1c-2.1 5.3-4.7 10.5-7.5 15.7-2.9-1.5-5.7-3-8.4-4.6-2.3-1.4-4.5-2.8-6.6-4.2 7.7-1.7 15.2-4 22.5-6.9m2-2c-8.8 3.6-17.9 6.4-27.2 8.3 2.8 2 5.7 3.8 8.8 5.7 3 1.9 6.1 3.5 9.4 5.2 3.5-6.4 6.5-12.7 9-19.2z"
        className="st1"
      />
      <path
        d="M185.8 334.3c9.5 0 19-1 28.3-2.8-.9 1.4-1.9 2.9-2.9 4.3s-2 2.9-3.1 4.3c-2.1 2.8-4.3 5.6-6.7 8.4-2.8-2.3-5.6-4.5-8.2-6.9-2.5-2.4-5-4.8-7.4-7.3z"
        className="st2"
      />
      <path
        d="M156.7 331.6c9.3 1.8 18.8 2.8 28.3 2.8-2.4 2.4-4.9 4.9-7.5 7.3-2.6 2.3-5.3 4.6-8.2 6.9-2.4-2.8-4.6-5.6-6.7-8.4-2-2.9-4-5.8-5.9-8.6z"
        className="st3"
      />
      <path
        d="M128.8 323.2c8.8 3.6 17.9 6.4 27.2 8.3-2.8 1.9-5.7 3.8-8.8 5.7-3 1.8-6.1 3.5-9.4 5.2-1.8-3.1-3.4-6.4-4.9-9.5-1.5-3.3-2.9-6.6-4.1-9.7z"
        className="st4"
      />
      <path
        d="M103 309.5c7.9 5.3 16.3 9.8 25.1 13.4-3.1 1.4-6.4 2.6-9.7 3.9-3.3 1.2-6.7 2.2-10.2 3.2-1.1-3.4-2.1-6.9-3-10.3-.9-3.4-1.6-6.9-2.2-10.2z"
        className="st0"
      />
      <path
        d="M80.4 291c6.7 6.7 14.1 12.8 22 18.1-3.3.7-6.8 1.3-10.3 1.9-3.5.5-7 .9-10.6 1.2-.4-3.6-.7-7.2-.9-10.7-.2-3.6-.3-7.1-.2-10.5z"
        className="st1"
      />
      <path
        d="M61.8 268.5c5.3 7.9 11.4 15.2 18.1 22-3.4 0-6.9 0-10.5-.1-3.5-.2-7.1-.5-10.7-.9.3-3.6.7-7.2 1.2-10.6.5-3.7 1.1-7.1 1.9-10.4z"
        className="st2"
      />
      <path
        d="M47.9 242.8c3.7 8.8 8.2 17.2 13.4 25.1-1.7-.3-3.4-.6-5.1-1-1.7-.4-3.5-.7-5.1-1.2-3.4-.9-6.9-1.8-10.3-3 1-3.5 2-6.9 3.2-10.2 1.3-3.4 2.5-6.6 3.9-9.7z"
        className="st3"
      />
      <path
        d="M39.4 214.9c1.9 9.3 4.6 18.4 8.3 27.2-6.4-2.5-12.8-5.5-19.1-9.1 1.7-3.2 3.3-6.3 5.2-9.4 1.8-3 3.6-5.9 5.6-8.7z"
        className="st4"
      />
      <path
        d="M35.4 188.4c.2 7.9.9 15.7 2.3 23.4-.7-.5-1.4-1-2.2-1.5-1.4-.9-2.9-2-4.2-3-2.6-2-5.1-3.9-7.5-6 1.8-2.3 3.9-4.8 6.2-7.3 1.7-1.9 3.5-3.8 5.4-5.6m1-2.6c-2.4 2.4-4.9 4.9-7.3 7.5-2.4 2.6-4.6 5.3-6.9 8.2 2.7 2.4 5.6 4.6 8.4 6.7 1.4 1.1 2.8 2.1 4.3 3.1 1.4 1 2.9 1.9 4.3 2.9-1.8-9.4-2.7-18.9-2.8-28.4z"
        className="st0"
      />
      <path
        d="M39.2 156.7c-1.8 9.3-2.8 18.8-2.8 28.3-2.4-2.4-4.9-4.9-7.3-7.5-2.3-2.6-4.6-5.3-6.9-8.2 2.8-2.4 5.6-4.6 8.4-6.7 2.8-2 5.8-4 8.6-5.9z"
        className="st1"
      />
      <path
        d="M47.6 128.8c-3.6 8.8-6.4 17.9-8.3 27.2-1.9-2.8-3.8-5.7-5.7-8.8-1.8-3-3.5-6.1-5.2-9.4 3.1-1.8 6.4-3.4 9.5-4.9 3.2-1.5 6.5-2.9 9.7-4.1z"
        className="st2"
      />
      <path
        d="M61.3 103c-5.3 7.9-9.8 16.3-13.4 25.1-1.4-3.1-2.6-6.4-3.9-9.7-1.2-3.3-2.2-6.7-3.2-10.2 3.4-1.1 6.9-2.1 10.3-3 3.4-.9 6.8-1.6 10.2-2.2z"
        className="st3"
      />
      <path
        d="M79.7 80.4c-6.7 6.7-12.8 14.1-18.1 22-.7-3.3-1.3-6.8-1.9-10.3-.5-3.5-.9-7-1.2-10.6 3.6-.4 7.2-.7 10.7-.9 3.7-.2 7.1-.3 10.5-.2z"
        className="st4"
      />
      <path
        d="M82.3 59.9c3.1.3 6.3.6 9.5 1.1 2.3.4 5 .8 7.7 1.3-6.4 4.5-12.5 9.5-18.2 15 0-2.5 0-5.2.2-7.8.2-2.9.4-6.3.8-9.6m-.9-1.2c-.4 3.6-.7 7.2-.9 10.7-.2 3.5-.2 7.1-.1 10.5 6.7-6.7 14.1-12.8 22-18.1-3.4-.7-6.8-1.3-10.3-1.9-3.6-.5-7.1-.9-10.7-1.2z"
        className="st0"
      />
      <path
        d="M128 47.9c-8.8 3.7-17.2 8.2-25.1 13.4.3-1.7.6-3.4 1-5.1.4-1.7.7-3.5 1.2-5.1.9-3.4 1.8-6.9 3-10.3 3.5 1 6.9 2 10.2 3.2 3.3 1.3 6.5 2.5 9.7 3.9z"
        className="st1"
      />
      <path
        d="M155.9 39.4c-9.3 1.9-18.4 4.6-27.2 8.3 2.5-6.4 5.5-12.8 9.1-19.1 3.2 1.7 6.3 3.3 9.4 5.2 3 1.8 5.9 3.6 8.7 5.6z"
        className="st2"
      />
      <path
        d="M185 36.4c-9.5 0-19 1-28.3 2.8.9-1.4 1.9-2.9 2.9-4.3s2-2.9 3.1-4.3c2.1-2.8 4.3-5.6 6.7-8.4 2.8 2.3 5.6 4.5 8.2 6.9 2.5 2.5 5 4.9 7.4 7.3z"
        className="st3"
      />
      <path
        d="M214 39.2c-9.3-1.8-18.8-2.8-28.3-2.8 2.4-2.4 4.9-4.9 7.5-7.3 2.6-2.3 5.3-4.6 8.2-6.9 2.4 2.8 4.6 5.6 6.7 8.4 2.1 2.8 4.1 5.8 5.9 8.6z"
        className="st4"
      />
      <path
        d="M242 47.6c-8.8-3.6-17.9-6.4-27.2-8.3 2.8-1.9 5.7-3.8 8.8-5.7 3-1.8 6.1-3.5 9.4-5.2 1.8 3.1 3.4 6.4 4.9 9.5 1.5 3.2 2.8 6.5 4.1 9.7z"
        className="st3"
      />
      <path
        d="M267.8 61.3c-7.9-5.3-16.3-9.8-25.1-13.4 3.1-1.4 6.4-2.6 9.7-3.9 3.3-1.2 6.7-2.2 10.2-3.2 1.1 3.4 2.1 6.9 3 10.3.9 3.4 1.5 6.8 2.2 10.2z"
        className="st4"
      />
      <path
        d="M290.4 79.7c-6.7-6.7-14.1-12.8-22-18.1 3.3-.7 6.8-1.3 10.3-1.9 3.5-.5 7-.9 10.6-1.2.4 3.6.7 7.2.9 10.7.2 3.7.2 7.1.2 10.5z"
        className="st0"
      />
      <path
        d="M309 102.3c-5.3-7.9-11.4-15.2-18.1-22 3.4 0 6.9 0 10.5.1 3.5.2 7.1.5 10.7.9-.3 3.6-.7 7.2-1.2 10.6-.6 3.6-1.2 7-1.9 10.4z"
        className="st1"
      />
      <path
        d="M322.9 128c-3.7-8.8-8.2-17.2-13.4-25.1 1.7.3 3.4.6 5.1 1 1.7.4 3.5.7 5.1 1.2 3.4.9 6.9 1.8 10.3 3-1 3.5-2 6.9-3.2 10.2-1.3 3.3-2.5 6.5-3.9 9.7z"
        className="st2"
      />
      <path
        d="M331.4 155.9c-1.9-9.3-4.6-18.4-8.3-27.2 6.4 2.5 12.8 5.5 19.1 9.1-1.7 3.2-3.3 6.3-5.2 9.4-1.8 3-3.6 5.9-5.6 8.7z"
        className="st3"
      />
      <path
        d="M333.1 158.9c.7.5 1.4 1 2.2 1.5 1.4 1 2.9 2 4.2 3 2.6 2 5.1 3.9 7.5 6-1.8 2.3-3.9 4.8-6.2 7.3l-5.4 5.7c-.2-7.9-1-15.8-2.3-23.5m-1.6-2.3c1.8 9.3 2.8 18.8 2.8 28.3 2.4-2.4 4.9-4.9 7.3-7.5 2.4-2.6 4.6-5.3 6.9-8.2-2.7-2.4-5.6-4.6-8.4-6.7-1.4-1.1-2.8-2.1-4.3-3.1-1.4-.9-2.8-1.8-4.3-2.8z"
        className="st4"
      />
      <path
        d="M309.9 211.9c1.9-8.9 2.8-17.9 2.8-27 2.3 2.3 4.7 4.6 7 7.2 2.2 2.5 4.5 5.1 6.6 7.9-5.3 4.5-10.7 8.5-16.4 11.9z"
        className="st3"
      />
      <path
        d="M301.3 238.1c3.8-8.3 6.6-16.9 8.5-25.8 1.8 2.7 3.7 5.6 5.3 8.5.8 1.5 1.7 3 2.5 4.5s1.5 3.1 2.3 4.6c-1.5.8-3 1.6-4.6 2.4-1.6.7-3.1 1.5-4.7 2.1-3 1.4-6.2 2.6-9.3 3.7z"
        className="st4"
      />
      <path
        d="M287.3 261.8c5.5-7.2 10.1-15.1 13.9-23.3.6 1.5 1.2 3.1 1.8 4.7.5 1.6 1.1 3.2 1.6 4.8 1 3.2 1.8 6.5 2.7 10a206 206 0 01-10 2.4c-3.5.4-6.7 1-10 1.4z"
        className="st0"
      />
      <path
        d="M268.4 281.9c6.9-5.9 13.1-12.6 18.6-19.8.5 3.2 1 6.6 1.2 9.9.1 1.7.3 3.4.4 5.1.1 1.7.1 3.4.1 5.2-1.7.1-3.4.2-5.2.2h-5.1c-3.3 0-6.7-.3-10-.6z"
        className="st1"
      />
      <path
        d="M245.8 297.5c8-4.3 15.5-9.5 22.4-15.4-.1 1.7-.2 3.3-.4 5-.2 1.7-.3 3.3-.5 5-.4 3.4-1.1 6.7-1.7 10.2-3.5-.6-6.8-1.2-10.1-2-3.4-.9-6.6-1.7-9.7-2.8z"
        className="st2"
      />
      <path
        d="M220.3 307.9c8.7-2.5 17.2-5.9 25.2-10.2-.9 3.1-1.8 6.4-3 9.6l-1.8 4.8c-.6 1.6-1.3 3.1-2.1 4.7-1.6-.6-3.2-1.3-4.8-2-1.6-.7-3.1-1.4-4.7-2.2-1.5-.8-3-1.5-4.5-2.3-1.5-.8-2.9-1.6-4.3-2.4z"
        className="st3"
      />
      <path
        d="M193.1 312.5c9.1-.6 18-2.1 26.8-4.5-3.1 5.9-6.7 11.6-10.9 17.2-2.9-1.9-5.7-4-8.3-6.1-2.6-2.2-5.2-4.4-7.6-6.6z"
        className="st4"
      />
      <path
        d="M165.6 311.2c9 1.4 18.1 1.8 27.1 1.3-2.1 2.5-4.4 4.9-6.8 7.4-2.4 2.3-4.9 4.7-7.5 7-2.4-2.6-4.7-5.1-6.8-7.7-2.1-2.7-4.1-5.3-6-8z"
        className="st0"
      />
      <path
        d="M139 304c8.4 3.3 17.2 5.7 26.2 7.1-2.6 2-5.4 4-8.2 5.8-2.8 1.8-5.8 3.6-8.9 5.2-.9-1.5-1.8-3-2.6-4.5s-1.6-3-2.4-4.6c-.8-1.5-1.5-3-2.2-4.5-.6-1.4-1.2-3-1.9-4.5z"
        className="st1"
      />
      <path
        d="M114.6 291.3c7.5 5.1 15.6 9.3 24.1 12.6-6 2.8-12.3 5.2-19 7.1-1.1-3.3-2.1-6.6-2.9-9.9-.9-3.3-1.6-6.6-2.2-9.8z"
        className="st2"
      />
      <path
        d="M76.7 251.8c4.7 7.7 10.3 14.9 16.6 21.5-6.6.1-13.4-.5-20.3-1.5.3-3.4.9-6.9 1.5-10.2.6-3.4 1.3-6.7 2.2-9.8z"
        className="st4"
      />
      <path
        d="M65 226.8c2.9 8.6 6.8 16.8 11.5 24.6-6.4-1.4-13-3.3-19.4-5.9.6-1.7 1.1-3.3 1.7-4.9.6-1.6 1.3-3.2 1.9-4.8.7-1.6 1.3-3.1 2-4.6.8-1.4 1.5-2.9 2.3-4.4z"
        className="st0"
      />
      <path
        d="M58.9 200c1 9 3 17.9 6 26.5-3.1-1.4-6-2.9-8.9-4.5-3-1.6-5.8-3.5-8.8-5.4l1.3-2.2 1.4-2.2c1-1.4 1.9-2.8 2.9-4.2 1.9-2.8 4-5.5 6.1-8z"
        className="st1"
      />
      <path
        d="M58.7 172.4c-.9 9-.9 18.2.1 27.2-2.6-2-5.2-4.1-7.8-6.4-2.5-2.3-5-4.6-7.4-7.1 2.4-2.5 4.9-4.9 7.3-7.2 2.7-2.3 5.2-4.4 7.8-6.5z"
        className="st5"
      />
      <path
        d="M64.4 145.5c-2.8 8.6-4.7 17.5-5.7 26.5-4.3-5-8.3-10.5-11.9-16.4 2.9-2 5.7-3.8 8.7-5.5 1.5-.8 2.9-1.7 4.4-2.4 1.5-.8 3-1.5 4.5-2.2z"
        className="st3"
      />
      <path
        d="M73.6 122.1c-3.7 6.5-6.8 13.3-9.2 20.3-.4-.7-.7-1.5-1.1-2.2-.7-1.5-1.4-3-2.1-4.6-1.3-2.9-2.4-5.9-3.3-8.5l1.4-.6 2.4-.9c1.6-.6 3.2-1.1 4.8-1.6 2.3-.6 4.7-1.3 7.1-1.9m2.2-1.6c-3.2.8-6.5 1.6-9.7 2.6-1.6.5-3.2 1.1-4.8 1.6l-2.5.9-2.4 1c1.2 3.3 2.3 6.5 3.7 9.6.7 1.6 1.4 3.1 2.1 4.6.7 1.5 1.5 3 2.3 4.4 2.9-8.6 6.7-16.9 11.3-24.7z"
        className="st4"
      />
      <path
        d="M92.4 98.4c-6.2 6.6-11.7 13.9-16.4 21.7-.8-3.1-1.6-6.4-2.3-9.7-.6-3.3-1.2-6.7-1.6-10.2 3.5-.5 6.8-1 10.2-1.3 3.4-.3 6.7-.5 10.1-.5z"
        className="st0"
      />
      <path
        d="M113.2 80.4c-7.5 5.2-14.4 11.1-20.6 17.7-.1-1.6-.2-3.3-.2-5v-5c0-3.4.3-6.8.6-10.3l2.6.1 2.6.2c1.7.2 3.4.3 5.1.5 3.4.6 6.7 1.2 9.9 1.8z"
        className="st1"
      />
      <path
        d="M137.5 67.4c-8.4 3.4-16.4 7.7-23.9 12.8.6-3.2 1.2-6.5 2-9.8.4-1.6.9-3.3 1.3-4.9.5-1.7 1-3.3 1.5-5 3.4 1 6.6 1.9 9.8 3.1 3.2 1.2 6.2 2.4 9.3 3.8z"
        className="st2"
      />
      <path
        d="M163.9 59.9c-8.9 1.5-17.7 4-26.1 7.4.6-1.5 1.2-3.1 1.9-4.6l2.1-4.5c1.5-3.1 3.1-6.1 4.9-9.1 6.2 3.1 12 6.8 17.2 10.8z"
        className="st3"
      />
      <path
        d="M191.4 58.2c-9.1-.4-18.2.1-27.1 1.6 1.8-2.7 3.8-5.4 5.9-8.1 2.1-2.6 4.4-5.2 6.7-7.8 2.7 2.3 5.2 4.6 7.6 6.9 2.5 2.5 4.8 4.9 6.9 7.4z"
        className="st0"
      />
      <path
        d="M218.6 62.5c-8.7-2.4-17.8-3.8-26.8-4.2 2.4-2.2 4.9-4.5 7.5-6.6 1.3-1 2.7-2.1 4-3.1 1.4-1 2.8-2.1 4.2-3 4.3 5.4 8 11 11.1 16.9z"
        className="st1"
      />
      <path
        d="M244.3 72.5c-8-4.2-16.5-7.5-25.3-9.9 1.4-.9 2.8-1.7 4.3-2.5s2.9-1.6 4.5-2.3c1.5-.8 3.1-1.5 4.6-2.2 1.6-.7 3.1-1.4 4.8-2 2.9 6.1 5.3 12.5 7.1 18.9z"
        className="st2"
      />
      <path
        d="M267.2 87.8c-6.9-5.8-14.5-11-22.5-15.2 3.1-1.1 6.3-2 9.6-2.9 3.3-.8 6.6-1.5 10.1-2.1.7 3.5 1.4 6.8 1.8 10.1.4 3.5.8 6.7 1 10.1z"
        className="st3"
      />
      <path
        d="M286.2 107.7c-5.6-7.2-11.9-13.8-18.8-19.6 1.6-.2 3.3-.3 5-.5 1.7-.1 3.3-.2 5-.2 1.7 0 3.4-.1 5.1-.1 1.7 0 3.4.1 5.2.2.1 6.8-.5 13.7-1.5 20.2z"
        className="st4"
      />
      <path
        d="M300.6 131.1c-3.9-8.2-8.6-16-14.1-23.2 3.3.3 6.5.9 9.9 1.4 3.3.7 6.7 1.4 10 2.3-1.5 6.9-3.4 13.4-5.8 19.5z"
        className="st0"
      />
      <path
        d="M309.6 157.2c-2-8.8-5-17.5-8.8-25.7 1.6.5 3.1 1.1 4.7 1.7 1.6.6 3.1 1.2 4.7 1.9s3.1 1.4 4.7 2.1c1.5.7 3.1 1.5 4.6 2.3-.7 1.6-1.4 3.1-2.2 4.7l-2.4 4.5c-1.7 2.9-3.5 5.7-5.3 8.5z"
        className="st1"
      />
      <path
        d="M312.7 184.5c-.1-9.1-1.1-18.1-3.1-27 1.5.8 2.8 1.7 4.2 2.6 1.4.9 2.8 1.9 4.2 2.8 2.8 2 5.4 4.1 8.1 6.3-2.1 2.8-4.3 5.4-6.5 8-2.2 2.6-4.6 5.1-6.9 7.3z"
        className="st2"
      />
      <path
        d="M288.1 210.5c2-8.4 3-17 3-25.6 1.1 1.1 2.3 2.2 3.4 3.3l1.7 1.7 1.6 1.8c1.1 1.2 2.1 2.5 3.2 3.7 1.1 1.3 2 2.6 3 3.9-5 4.4-10.5 8.1-15.9 11.2z"
        className="st1"
      />
      <path
        d="M263.3 256.8c5.9-6.3 10.9-13.4 15-21 .5 1.5.9 3 1.4 4.6.4 1.6.8 3.1 1.2 4.7.8 3.2 1.3 6.4 1.8 9.7-1.6.3-3.3.6-4.9.8-1.6.2-3.2.5-4.9.6-3.3.4-6.4.6-9.6.6z"
        className="st3"
      />
      <path
        d="M243.1 274c3.6-2.3 7-5 10.4-7.7 3.3-2.8 6.4-5.7 9.3-8.9.5 6.3.3 12.8-.5 19.5-6.7-.5-13.1-1.4-19.2-2.9z"
        className="st4"
      />
      <path
        d="M219.3 285.6c8.1-2.8 16-6.5 23.2-11.2-.3 1.6-.6 3.1-1 4.7s-.8 3.1-1.2 4.7c-.4 1.5-.9 3.1-1.5 4.7-.5 1.6-1.1 3.2-1.7 4.7-3.2-1-6.3-2.1-9.3-3.4-1.5-.6-2.9-1.2-4.4-2-1.3-.8-2.8-1.5-4.1-2.2z"
        className="st5"
      />
      <path
        d="M193.3 290.8c8.6-.7 17.1-2.3 25.3-5-1.3 2.8-2.8 5.7-4.4 8.5-1.7 2.7-3.4 5.6-5.4 8.3l-4.2-2.7c-1.4-.9-2.7-1.9-4-2.9-2.5-2-5-4.1-7.3-6.2z"
        className="st1"
      />
      <path
        d="M169.1 291c5.5.8 11 1.2 16.4 1.2 1.5 0 3.1 0 4.6-.1-1.5 1.7-3.1 3.5-4.7 5.1-1.1 1.1-2.3 2.3-3.5 3.4l-1.8 1.7-1.1.9c-.9-1-1.8-1.9-2.6-2.9-.9-1-1.8-2.1-2.7-3.2l-.4-.5-.4-.5c-.9-1.1-1.7-2.2-2.5-3.3-.4-.6-.9-1.2-1.3-1.8m-2.3-1.5l2.7 3.9c.9 1.3 1.9 2.5 2.9 3.8 1 1.3 2.1 2.6 3.1 3.8 1.1 1.2 2.2 2.4 3.4 3.7l1.9-1.6 1.8-1.7c1.2-1.1 2.4-2.3 3.5-3.4 2.3-2.3 4.4-4.7 6.4-7.1-2.3.2-4.7.2-7 .2-6.2 0-12.5-.6-18.7-1.6z"
        className="st2"
      />
      <path
        d="M141.5 281.6c7.9 3.5 16.1 6.2 24.6 7.8-2.5 1.9-5.2 3.6-8 5.3-1.4.8-2.8 1.6-4.3 2.4l-2.2 1.2-2.2 1.1c-.8-1.5-1.6-2.9-2.3-4.4l-2.1-4.5c-1.3-2.9-2.5-6-3.5-8.9z"
        className="st3"
      />
      <path
        d="M120.3 270.1c5.6 4.3 11.6 8 17.8 11.1-5.1 1.9-10.2 3.3-15.1 4.4-1.3-4.9-2.2-10.1-2.7-15.5m-1.3-2.4c.5 6.2 1.5 12.7 3.3 19.2 6.5-1.3 12.8-3.2 18.6-5.5-7.8-3.7-15.2-8.3-21.9-13.7z"
        className="st4"
      />
      <path
        d="M100.6 248.5c.6.9 1.3 1.7 2 2.6l2 2.5 2.1 2.4c.7.8 1.4 1.6 2.2 2.4l2.3 2.3c.8.8 1.6 1.5 2.4 2.2 1.5 1.5 3.2 2.9 4.9 4.3-3.1.4-6.3.7-9.6.8-1.6.1-3.3.1-4.9.1-1.6 0-3.3-.1-5-.2 0-1.7 0-3.3.1-5 .1-1.7.2-3.3.3-4.9.2-1.6.3-3.2.5-4.8.2-1.5.4-3.1.7-4.7z"
        className="st0"
      />
      <path
        d="M87.5 225.5c1.6 4 3.5 7.9 5.6 11.6l1.6 2.8.8 1.4.9 1.4 1.8 2.7c.6.9 1.3 1.7 1.9 2.6-1.6-.2-3.2-.4-4.7-.7-1.6-.3-3.1-.6-4.7-.9l-2.4-.5-2.4-.6c-1.6-.4-3.2-.9-4.8-1.4 1.7-6.6 3.8-12.7 6.4-18.4z"
        className="st1"
      />
      <path
        d="M80.7 199.9c1.2 8.5 3.3 17 6.6 24.9-3-1.1-5.8-2.5-8.8-3.9-2.9-1.5-5.8-3.1-8.6-4.8.8-1.5 1.7-2.9 2.5-4.3l1.3-2.1 1.4-2.1c.9-1.4 1.8-2.7 2.8-4 .8-1.2 1.8-2.5 2.8-3.7z"
        className="st2"
      />
      <path
        d="M79 175.8c-.6 7.1-.6 14.2.2 21.1-1.8-1.4-3.5-2.8-5.4-4.4l-.1-.1c-2-1.8-4.1-3.7-6.4-6 4-4.1 7.8-7.6 11.7-10.6m1.3-2.4c-5.1 3.8-9.9 8.1-14.5 13 2.4 2.4 4.7 4.7 7.2 6.8 2.5 2.1 4.9 4.1 7.5 6-1.1-8.6-1.1-17.3-.2-25.8z"
        className="st3"
      />
      <path
        d="M86.6 147.6c-1.6 4-2.8 8.2-3.9 12.3-1 4.2-1.8 8.4-2.3 12.7-4.1-4.8-7.7-10.2-11.1-16 5.7-3.6 11.4-6.6 17.3-9z"
        className="st4"
      />
      <path
        d="M99.1 124.3c-5 7.1-9.2 14.7-12.3 22.7l-1-2.2-.9-2.2-1.8-4.5c-.6-1.5-1.1-3.1-1.6-4.6-.5-1.6-1-3.2-1.4-4.8 3.2-1 6.3-2 9.5-2.7 1.6-.4 3.1-.7 4.7-1 1.7-.3 3.3-.5 4.8-.7z"
        className="st0"
      />
      <path
        d="M117 104.7c-6.5 5.6-12.5 12-17.5 19-.3-1.6-.5-3.1-.8-4.7-.2-1.6-.5-3.2-.6-4.8-.3-3.2-.5-6.6-.5-9.9 6.6-.5 13.2-.2 19.4.4z"
        className="st5"
      />
      <path
        d="M139.2 90.2c-7.8 3.7-15 8.5-21.7 14 .2-3.1.5-6.4 1-9.5.2-1.6.5-3.2.8-4.9.3-1.6.7-3.2 1.1-4.8 3.3.5 6.5 1.4 9.6 2.2 1.6.4 3.1.9 4.6 1.4 1.7.6 3.1 1 4.6 1.6z"
        className="st2"
      />
      <path
        d="M148 73.4c2.3 1.1 4.8 2.4 7.7 4.1 1.4.8 2.8 1.7 4.1 2.5l1.9 1.2c-6.6 1.5-13.3 3.7-20 6.7.2-.7.5-1.4.7-2.1.5-1.4 1.1-2.9 1.8-4.4 1.1-2.8 2.5-5.5 3.8-8m-.5-1.4c-1.6 3-3 5.9-4.3 8.9l-1.8 4.5c-.5 1.5-1.1 3-1.5 4.5 7.8-3.7 16-6.5 24.5-8.2l-2-1.4-2-1.3c-1.3-.9-2.7-1.7-4.1-2.5-2.8-1.5-5.8-3.1-8.8-4.5z"
        className="st3"
      />
      <path
        d="M190.8 79.8c-8.6-.5-17.3.2-25.8 1.8.8-1.3 1.7-2.7 2.6-4 .9-1.3 1.9-2.6 2.9-3.9 2-2.6 4.1-5.1 6.4-7.6 2.6 2.1 5.1 4.4 7.4 6.6 2.2 2.4 4.4 4.6 6.5 7.1z"
        className="st4"
      />
      <path
        d="M216.9 84.4c-8.2-2.6-16.8-4.1-25.4-4.6 1.1-1.1 2.3-2.2 3.5-3.2 1.2-1 2.4-2 3.7-3.1 2.6-2.1 5.2-3.9 8-5.8 2 2.7 3.8 5.5 5.5 8.2l2.4 4.2c.9 1.5 1.6 2.9 2.3 4.3z"
        className="st0"
      />
      <path
        d="M241 95.4c-7.3-4.6-15.2-8.2-23.4-10.8 1.4-.8 2.8-1.5 4.2-2.2 1.4-.7 2.9-1.4 4.4-2 3-1.4 6-2.5 9.2-3.6.6 1.5 1.2 3.1 1.8 4.7.5 1.6 1.1 3.1 1.5 4.7.8 3.1 1.7 6.1 2.3 9.2z"
        className="st1"
      />
      <path
        d="M261.6 112.1c-6-6.2-12.7-11.7-20-16.3 6.1-1.6 12.5-2.6 19.2-3.2.4 3.4.8 6.6.8 9.9.1 1.6.1 3.2.1 4.8 0 1.6 0 3.2-.1 4.8z"
        className="st2"
      />
      <path
        d="M277.4 133.3c-4.3-7.5-9.4-14.5-15.4-20.7 1.6 0 3.2 0 4.8.1l4.8.3c3.2.3 6.5.7 9.8 1.3-.2 1.7-.4 3.3-.7 4.9-.3 1.6-.6 3.3-.9 4.8-.6 3.2-1.5 6.4-2.4 9.3z"
        className="st3"
      />
      <path
        d="M287.5 157.9c-2.3-8.3-5.5-16.4-9.7-23.9 6 1.6 12.3 3.7 18.3 6.5-2.3 6.2-5.3 12-8.6 17.4z"
        className="st4"
      />
      <path
        d="M289.3 160.7c1.9 1.1 4 2.3 5.9 3.7 1.3.9 2.7 1.8 4 2.8 1 .8 2.1 1.6 3.1 2.4-1.8 2.5-3.7 4.8-5.5 6.8-1.5 1.8-3.2 3.5-4.7 5.1-.2-7-1.2-13.9-2.8-20.8m-1.6-2.2c2.2 8.3 3.3 16.9 3.4 25.6 2.2-2.2 4.5-4.5 6.6-7 2.1-2.5 4.2-5.1 6.1-7.8-1.3-1.1-2.6-2.1-3.9-3.1-1.4-1-2.7-1.9-4-2.8-2.7-1.7-5.5-3.3-8.2-4.9z"
        className="st0"
      />
      <path
        d="M266.3 208.6c1.1-3.9 1.9-7.9 2.5-12 .5-4 .8-8.1.7-12.2 4.5 4 8.6 8.7 12.3 14-5 4.1-10.2 7.5-15.5 10.2z"
        className="st4"
      />
      <path
        d="M255.8 231.4c2.2-3.4 4.2-7 5.9-10.7 1.7-3.7 3.2-7.5 4.3-11.4 3.1 5.2 5.6 10.8 7.7 17-5.9 2.4-12 4.1-17.9 5.1z"
        className="st0"
      />
      <path
        d="M254.9 234.7c1 4.7 1.5 9.5 1.7 14.8-2.2.2-4.3.3-6.5.3-2.8 0-5.6-.1-8.3-.4 4.9-4.4 9.3-9.3 13.1-14.7m.5-2.7c-4.5 6.8-10 12.9-16.3 18.1 3.5.5 7.2.7 11 .7 2.5 0 5.1-.1 7.7-.4-.2-6.4-.9-12.6-2.4-18.4z"
        className="st1"
      />
      <path
        d="M217.7 263.1c1.9-.7 3.7-1.7 5.6-2.5 1.8-1 3.6-1.9 5.3-3 1.8-1 3.4-2.2 5.1-3.3 1.6-1.2 3.3-2.4 4.9-3.7-.2 3-.6 6-1.1 9.1-.6 3-1.2 6.2-2.2 9.2-3.1-.6-6.2-1.5-9.2-2.5-2.9-1-5.7-2-8.4-3.3z"
        className="st2"
      />
      <path
        d="M193.3 269.1c4.1-.3 8.1-1.1 12-2 4-.9 7.8-2.2 11.6-3.7-2.1 5.6-4.9 11.2-8.5 16.6-5.5-3.2-10.6-6.8-15.1-10.9z"
        className="st3"
      />
      <path
        d="M168.3 267.8c2 .5 4 .7 6 1 2 .2 4 .5 6.1.6 4.1.3 8.2.2 12.2-.2-3.7 4.7-8 9.3-13 13.3-2.2-2.3-4.3-4.8-6.2-7.2-1.8-2.5-3.6-4.9-5.1-7.5z"
        className="st4"
      />
      <path
        d="M144.8 259.1c1.8 1 3.6 1.9 5.4 2.8 1.9.8 3.7 1.7 5.6 2.3 3.8 1.5 7.7 2.6 11.7 3.4-4.9 3.4-10.4 6.5-16.3 8.9-1.5-2.8-2.7-5.8-3.8-8.7-1-2.9-1.9-5.8-2.6-8.7z"
        className="st0"
      />
      <path
        d="M124.8 243.8c5.7 5.9 12.2 10.9 19.3 14.9-5.7 1.8-11.9 3.1-18.3 3.7-.9-6.4-1.3-12.6-1-18.6z"
        className="st1"
      />
      <path
        d="M110.3 223.4c1.9 3.6 4 7.1 6.3 10.5 2.4 3.3 5 6.5 7.8 9.4-6 0-12.2-.5-18.5-1.8.8-6.5 2.3-12.5 4.4-18.1z"
        className="st2"
      />
      <path
        d="M102.4 199.6c.7 4 1.6 8 2.9 11.9 1.3 3.9 2.8 7.7 4.6 11.3-5.8-1.7-11.5-4.1-17.2-7.2 2.8-5.9 6.1-11.3 9.7-16z"
        className="st3"
      />
      <path
        d="M101.9 174.5c-.5 4-.7 8.1-.7 12.2.1 4.1.4 8.2 1.1 12.2-5-3.3-9.7-7.3-14.3-12 4.4-4.8 9.1-8.9 13.9-12.4z"
        className="st4"
      />
      <path
        d="M108.8 150.4c-1.7 3.7-3.1 7.5-4.3 11.4-1.1 3.9-2 7.9-2.5 11.9-3.8-4.6-7.2-9.9-10.1-15.6 5.6-3.3 11.3-5.8 16.9-7.7z"
        className="st0"
      />
      <path
        d="M122.6 129.4c-5.4 6.1-10 13-13.4 20.3-2.3-5.6-3.9-11.5-5-17.9 6.2-1.5 12.4-2.3 18.4-2.4z"
        className="st1"
      />
      <path
        d="M141.9 113.4c-3.5 2.1-6.8 4.5-10 7.1-3.1 2.6-6.1 5.4-8.8 8.4-.5-6-.4-12.2.5-18.6 6.4.3 12.5 1.4 18.3 3.1z"
        className="st4"
      />
      <path
        d="M165 103.7c-4 .9-7.8 2.3-11.6 3.8s-7.4 3.4-10.9 5.5c1.3-5.9 3.2-11.8 5.9-17.7 6.1 2.3 11.6 5.1 16.6 8.4z"
        className="st0"
      />
      <path
        d="M190 101.4c-2-.2-4.1-.1-6.1-.1l-3.1.1-1.5.1-1.5.1c-4.1.3-8.1 1-12.1 2 2.9-5.2 6.6-10.3 10.9-15.1l1.9 1.5 1.8 1.6c1.2 1.1 2.4 2.1 3.5 3.2 2.2 2.1 4.3 4.2 6.2 6.6z"
        className="st3"
      />
      <path
        d="M205.3 91.6c1.7 2.4 3.1 4.9 4.4 7.1 1 1.9 2 3.8 2.9 5.9-.6-.2-1.2-.4-1.9-.6-.5-.2-1.1-.3-1.6-.5-.5-.1-1.1-.3-1.6-.4-1.4-.4-2.9-.8-4.3-1-1.6-.4-3.2-.6-4.7-.9-.5-.1-.9-.1-1.4-.2-.6-.1-1.3-.2-1.9-.2-.4 0-.8-.1-1.1-.1l-.6-.1 1.5-1.3c1.3-1.1 2.4-2 3.6-2.9 1.6-1.4 4-3.2 6.7-4.8m.3-1.4c-2.8 1.6-5.4 3.5-7.9 5.3-1.2.9-2.4 1.9-3.6 2.9l-1.7 1.5-1.7 1.6 1.5.1 1.5.2 3 .3c2 .3 4 .6 6 1.1 2 .4 4 1 5.9 1.5 1.9.6 3.9 1.2 5.8 1.9-1.1-2.8-2.5-5.5-4-8.3-1.3-2.8-3-5.5-4.8-8.1z"
        className="st4"
      />
      <path
        d="M236.5 118.6c-3.2-2.5-6.7-4.7-10.2-6.7-3.5-2-7.3-3.7-11.1-5.2 5.4-2.7 11.3-4.9 17.5-6.4 2 6.2 3.3 12.3 3.8 18.3z"
        className="st0"
      />
      <path
        d="M254 136.6c-2.4-3.3-5-6.4-7.8-9.4s-5.9-5.7-9.1-8.2c5.9-.9 12.2-1.3 18.6-.9.1 6.5-.5 12.7-1.7 18.5z"
        className="st5"
      />
      <path
        d="M265.3 159c-1.3-3.9-2.8-7.6-4.7-11.3-1.9-3.6-3.9-7.1-6.3-10.5 5.9.8 12 2.4 18 4.6-1.7 6.2-4.1 12-7 17.2z"
        className="st2"
      />
      <path
        d="M269.5 183.7c-.1-4.1-.5-8.2-1.1-12.2-.7-4-1.6-8-2.9-11.9 5.5 2.5 10.7 5.8 15.9 9.7-3.6 5.5-7.6 10.3-11.9 14.4z"
        className="st3"
      />
      <path
        d="M244.4 206.1c2.5-7.2 3.7-14.8 3.5-22.5 4.3 3.7 8.3 8.2 11.7 13.3-4.8 3.9-10 7-15.2 9.2z"
        className="st1"
      />
      <path
        d="M233 226c5-5.8 8.8-12.5 11.4-19.7 2.7 5 4.8 10.6 6.1 16.7-6 1.8-11.9 2.8-17.5 3z"
        className="st2"
      />
      <path
        d="M215.1 240.4c6.7-3.6 12.8-8.5 17.7-14.3.7 5.6.6 11.6-.3 17.8-6.2-.4-12.1-1.6-17.4-3.5z"
        className="st3"
      />
      <path
        d="M193.2 247.4c7.6-.9 15-3.3 21.7-6.9-1.4 5.5-3.6 11.1-6.7 16.4-5.7-2.5-10.7-5.8-15-9.5z"
        className="st4"
      />
      <path
        d="M170.2 246.1c7.4 1.8 15.1 2.3 22.7 1.4-3.3 4.6-7.4 9-12.2 12.9-4.3-4.5-7.8-9.3-10.5-14.3z"
        className="st0"
      />
      <path
        d="M149.3 236.5c6.2 4.4 13.3 7.6 20.7 9.5-4.7 3.1-10.1 5.7-16 7.6-2.4-5.7-4-11.5-4.7-17.1z"
        className="st1"
      />
      <path
        d="M133.3 220c4.2 6.4 9.6 11.9 15.9 16.3-5.5 1.2-11.5 1.7-17.7 1.3-.3-6.1.4-12.1 1.8-17.6z"
        className="st2"
      />
      <path
        d="M123.8 201.5c1.5 5.9 3.9 11.6 7.1 16.8-4.5-.9-9-2.3-13.4-4.2 1.7-4.5 3.8-8.7 6.3-12.6m.5-2.6c-3.3 4.6-6.1 9.9-8.1 15.8 5.7 2.6 11.4 4.3 17 5.2-4.2-6.4-7.3-13.6-8.9-21z"
        className="st3"
      />
      <path
        d="M123.6 175.9c-1.2 7.5-.9 15.3.7 22.8-4.9-2.8-9.6-6.5-14-11 4-4.7 8.5-8.7 13.3-11.8z"
        className="st4"
      />
      <path
        d="M131.2 154.2c-3.8 6.6-6.4 13.9-7.6 21.5-3.6-4.4-6.7-9.5-9.1-15.3 5.5-2.9 11.1-5 16.7-6.2z"
        className="st0"
      />
      <path
        d="M166.3 125.8c-7.3 2.3-14.1 6-20 10.8.4-5.7 1.5-11.5 3.6-17.4 6 1.5 11.5 3.8 16.4 6.6z"
        className="st2"
      />
      <path
        d="M189.1 123c-7.6-.5-15.3.5-22.6 2.8 2.4-5.1 5.6-10.2 9.6-14.9 5.1 3.5 9.5 7.6 13 12.1z"
        className="st1"
      />
      <path
        d="M211.4 128.5c-6.9-3.2-14.4-5.1-22.1-5.5 4.1-3.9 8.9-7.5 14.4-10.5 3.4 5.2 6 10.6 7.7 16z"
        className="st2"
      />
      <path
        d="M230.2 141.8c-5.3-5.5-11.7-10-18.6-13.2 5.2-2.2 11-3.8 17.2-4.5 1.3 6 1.8 12 1.4 17.7z"
        className="st3"
      />
      <path
        d="M242.9 160.9c-3-7-7.3-13.5-12.6-19 5.7-.2 11.6.5 17.7 1.9-.9 6.2-2.7 12-5.1 17.1z"
        className="st4"
      />
      <path
        d="M243 161.1c5.3 1.9 10.7 4.6 15.8 8.2-3.1 5.4-6.8 10.1-10.9 14-.3-7.6-1.9-15.2-4.9-22.2m-1.9-1.8l1 2.3c2.9 6.9 4.5 14.2 4.8 21.9l.1 2.5 1.8-1.7c4.2-4.1 8-8.9 11.1-14.3l.5-.9-.8-.6c-5.1-3.6-10.5-6.4-16-8.3l-2.5-.9z"
        className="st0"
      />
      <path
        d="M222 203.8l.6-1.2.5-1.2c.3-.8.7-1.6 1-2.4l.8-2.5c.1-.4.3-.8.4-1.3l.2-1.3.5-2.6.2-2.6.1-1.3v-3.9c1 .8 2 1.7 3 2.7l1.5 1.5c.5.5.9 1 1.4 1.6.9 1.1 1.8 2.2 2.7 3.4.8 1.2 1.6 2.4 2.3 3.8-.6.4-1.2.9-1.8 1.3-.6.4-1.3.8-1.9 1.2-1.3.7-2.5 1.4-3.8 2.1-1.3.6-2.6 1.1-3.9 1.6-.6.2-1.3.5-1.9.7-.6.1-1.3.2-1.9.4z"
        className="st4"
      />
      <path
        d="M207.8 219.6l2.2-1.5c.7-.5 1.3-1.1 2-1.7 1.4-1.1 2.5-2.4 3.8-3.6 2.2-2.7 4.4-5.4 5.9-8.6 2 5 2.9 10.5 3 16.6-3.1.2-5.9.4-8.8.1-1.4-.1-2.8-.3-4.1-.5-1.4-.1-2.7-.4-4-.8z"
        className="st0"
      />
      <path
        d="M187.7 226.3c7-.5 13.8-2.6 19.7-6.4-.2 1.4-.5 2.6-.8 3.9-.2.7-.3 1.3-.5 2l-.3 1-.4 1c-1 2.6-2.2 5.4-3.7 7.9-5.5-2.3-10.3-5.8-14-9.4z"
        className="st1"
      />
      <path
        d="M167 222l1.2.6 1.2.5c.8.3 1.6.7 2.4 1l2.5.8c.4.1.8.3 1.3.4l1.3.2 2.6.5 2.6.2 1.3.1h3.9c-.8 1-1.7 2-2.7 3l-1.5 1.5c-.5.5-1 .9-1.6 1.4-1.1.9-2.2 1.8-3.4 2.7-1.2.8-2.4 1.6-3.8 2.3-.4-.6-.9-1.2-1.3-1.8-.4-.6-.8-1.3-1.2-1.9-.7-1.3-1.4-2.5-2.1-3.8-.6-1.3-1.1-2.6-1.6-3.9-.2-.6-.5-1.3-.7-1.9-.1-.6-.3-1.3-.4-1.9z"
        className="st2"
      />
      <path
        d="M151.1 207.8l1.5 2.2c.5.7 1.1 1.3 1.7 2 1.1 1.4 2.4 2.5 3.6 3.8 2.7 2.2 5.4 4.4 8.6 5.9-5 2-10.5 2.9-16.6 3-.2-3.1-.4-5.9-.1-8.8.1-1.4.3-2.8.5-4.1.2-1.4.5-2.7.8-4z"
        className="st3"
      />
      <path
        d="M144.5 187.7c.5 7 2.6 13.8 6.4 19.7-1.4-.2-2.6-.5-3.9-.8-.7-.2-1.3-.3-2-.5l-1-.3-1-.4c-2.6-1-5.4-2.2-7.9-3.7 2.2-5.5 5.7-10.3 9.4-14z"
        className="st4"
      />
      <path
        d="M148.8 167l-.6 1.2-.5 1.2c-.3.8-.7 1.6-1 2.4l-.8 2.5c-.1.4-.3.8-.4 1.3l-.2 1.3-.5 2.6-.2 2.6-.1 1.3v3.9c-1-.8-2-1.7-3-2.7l-1.5-1.5c-.5-.5-.9-1-1.4-1.6-.9-1.1-1.8-2.2-2.7-3.4-.8-1.2-1.6-2.4-2.3-3.8.6-.4 1.2-.9 1.8-1.3.6-.4 1.3-.8 1.9-1.2 1.3-.7 2.5-1.4 3.8-2.1 1.3-.6 2.6-1.1 3.9-1.6.6-.2 1.3-.5 1.9-.7.6-.1 1.3-.3 1.9-.4z"
        className="st0"
      />
      <path
        d="M162.9 151.1l-2.2 1.5c-.7.5-1.3 1.1-2 1.7-1.4 1.1-2.5 2.4-3.8 3.6-2.2 2.7-4.4 5.4-5.9 8.6-2-5-2.9-10.5-3-16.6 3.1-.2 5.9-.4 8.8-.1 1.4.1 2.8.3 4.1.5 1.4.2 2.8.5 4 .8z"
        className="st1"
      />
      <path
        d="M169.5 136.4c3.9 1.7 7.6 4.2 11 7.2-5.6.7-11 2.4-15.7 5.1.1-.3.1-.5.2-.8l.2-.7c.2-.7.3-1.3.5-2l.3-1 .3-.9c.8-1.8 1.8-4.5 3.2-6.9m-.4-1.4c-1.6 2.5-2.8 5.3-3.7 7.9l-.4 1-.3 1c-.2.7-.4 1.4-.5 2-.3 1.4-.6 2.6-.8 3.9 5.9-3.8 12.7-5.9 19.7-6.4-3.8-3.6-8.5-7.1-14-9.4z"
        className="st0"
      />
      <path
        d="M203.8 148.8l-1.2-.6-1.2-.5c-.8-.3-1.6-.7-2.4-1l-2.5-.8c-.4-.1-.8-.3-1.3-.4l-1.3-.2-2.6-.5-2.6-.2-1.3-.1h-3.9c.8-1 1.7-2 2.7-3l1.5-1.5c.5-.5 1-.9 1.6-1.4 1.1-.9 2.2-1.8 3.4-2.7 1.2-.8 2.4-1.6 3.8-2.3.4.6.9 1.2 1.3 1.8.4.6.8 1.3 1.2 1.9.7 1.3 1.4 2.5 2.1 3.8.6 1.3 1.1 2.6 1.6 3.9.2.6.5 1.3.7 1.9.1.6.2 1.3.4 1.9z"
        className="st1"
      />
      <path
        d="M219.6 162.9l-1.5-2.2c-.5-.7-1.1-1.3-1.7-2-1.1-1.4-2.4-2.5-3.6-3.8-2.7-2.2-5.4-4.4-8.6-5.9 5-2 10.5-2.9 16.6-3 .2 3.1.4 5.9.1 8.8-.1 1.4-.3 2.8-.5 4.1-.1 1.4-.4 2.8-.8 4z"
        className="st2"
      />
      <path
        d="M226.3 183c-.5-7-2.6-13.8-6.4-19.7 1.4.2 2.6.5 3.9.8.7.2 1.3.3 2 .5l1 .3 1 .4c2.6 1 5.4 2.2 7.9 3.7-2.3 5.6-5.8 10.3-9.4 14z"
        className="st3"
      />
      <path
        d="M197.1 200.9c2.3-1.8 4.3-4.1 5.6-6.7 1.3-2.6 2-5.5 2.1-8.5 3.8 3 6.8 7.8 8.1 13.7-5.5 2.4-11.1 2.8-15.8 1.5z"
        className="st1"
      />
      <path
        d="M177.8 203.3c5.4 2.4 11.9 1.9 17-.9-.7 4.7-3.3 9.7-7.8 13.8-4.8-3.5-8-8.2-9.2-12.9z"
        className="st5"
      />
      <path
        d="M166 187.8c.7 5.9 4.2 11.3 9.3 14.3-4.5 1.8-10.1 2-15.9.2.7-6.1 3.2-11.1 6.6-14.5z"
        className="st3"
      />
      <path
        d="M168.1 170.2c1.1 0 2.1.1 3.1.2-1.7 1.6-3.1 3.5-4.2 5.6-1 2.1-1.7 4.4-2 6.7-2.8-2.8-4.8-6.5-5.9-10.7 3-1.1 6.1-1.8 9-1.8m0-1.1c-3.3 0-6.8.7-10.3 2.2 1.3 5.9 4.3 10.7 8.1 13.7 0-2.9.8-5.9 2.1-8.5 1.4-2.6 3.3-4.9 5.6-6.7-1.7-.4-3.5-.7-5.5-.7z"
        className="st2"
      />
      <path
        d="M192.9 167.4c-5.4-2.4-11.9-1.9-17 .9.7-4.7 3.3-9.7 7.8-13.8 4.9 3.6 8 8.3 9.2 12.9z"
        className="st4"
      />
      <path
        fill="#fbad2c"
        d="M204.7 183c-.7-5.9-4.2-11.3-9.3-14.3 4.5-1.8 10.1-2 15.9-.2-.7 6-3.2 11.1-6.6 14.5z"
      />
      <path
        d="M133.3 138.9c-.4 0-.7.3-.7.7 0 .4.3.7.7.7.4 0 .7-.3.7-.7-.1-.4-.4-.7-.7-.7zm0-2.8c-.4 0-.7.3-.7.7s.3.7.7.7c.4 0 .7-.3.7-.7s-.4-.7-.7-.7zm-3.6.2c-.1.1-.1.2-.1.4 0 .4.3.7.7.7.4 0 .7-.3.7-.7 0-.2-.1-.4-.2-.5-.5.1-.8.1-1.1.1zm3.6 5.5c-.4 0-.7.3-.7.7s.3.7.7.7c.4 0 .7-.3.7-.7s-.4-.7-.7-.7zm0 2.9c-.4 0-.7.3-.7.7s.3.7.7.7c.4 0 .7-.3.7-.7s-.4-.7-.7-.7zm-3.1-5.8c-.4 0-.7.3-.7.7 0 .4.3.7.7.7.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7zm0 8.6c-.2 0-.4.1-.5.3.1.3.1.6.2.9.1.1.2.1.3.1.4 0 .7-.3.7-.7 0-.3-.3-.6-.7-.6zm.1 2.9l.3 1.2c.2-.1.3-.3.3-.5 0-.4-.3-.7-.6-.7zm-.1-8.6c-.4 0-.7.3-.7.7s.3.7.7.7c.4 0 .7-.3.7-.7s-.3-.7-.7-.7zm0 2.9c-.4 0-.7.3-.7.7s.3.7.7.7c.4 0 .7-.3.7-.7s-.3-.7-.7-.7zm3.1 2.8c-.4 0-.7.3-.7.7s.3.7.7.7c.4 0 .7-.3.7-.7s-.4-.7-.7-.7zm9.2-8.6c-.4 0-.7.3-.7.7 0 .2.1.4.3.6l.9-.9c0-.2-.2-.4-.5-.4zm-3.1-2.8c-.4 0-.7.3-.7.7s.3.7.7.7c.4 0 .7-.3.7-.7s-.3-.7-.7-.7zm2.7.1c-.1.1-.2.3-.2.5 0 .4.3.7.7.7.4 0 .7-.3.7-.7 0-.2-.1-.3-.2-.4-.4 0-.7 0-1-.1zm-2.7 2.7c-.4 0-.7.3-.7.7 0 .4.3.7.7.7.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7zm-3 5.8c-.4 0-.7.3-.7.7s.3.7.7.7c.4 0 .7-.3.7-.7s-.4-.7-.7-.7zm8.6-8.1v.2c0 .3.2.5.4.6.3-.2.5-.4.7-.6-.4-.1-.7-.2-1.1-.2zm-8.6 5.2c-.4 0-.7.3-.7.7s.3.7.7.7c.4 0 .7-.3.7-.7s-.4-.7-.7-.7zm3 0c-.4 0-.7.3-.7.7 0 .3.2.6.5.6.3-.3.5-.6.8-.8 0-.3-.3-.5-.6-.5zm-3-2.9c-.4 0-.7.3-.7.7 0 .4.3.7.7.7.4 0 .7-.3.7-.7-.1-.4-.4-.7-.7-.7zm0-2.8c-.4 0-.7.3-.7.7s.3.7.7.7c.4 0 .7-.3.7-.7s-.4-.7-.7-.7zM286 229.9c-.4 0-.7.3-.7.7 0 .4.3.7.7.7.4 0 .7-.3.7-.7-.1-.4-.4-.7-.7-.7zm-.6 3.3l.9-.3c-.1 0-.2-.1-.3-.1-.3 0-.5.1-.6.4zm-2.1-7.8c.2-.1.3-.3.3-.5v-.1c-.2.1-.2.3-.3.6zm2.7 1.6c-.4 0-.7.3-.7.7s.3.7.7.7c.4 0 .7-.3.7-.7s-.4-.7-.7-.7zm0-5.7c-.4 0-.7.3-.7.7 0 .4.3.7.7.7.4 0 .7-.3.7-.7-.1-.4-.4-.7-.7-.7zm0 2.9c-.4 0-.7.3-.7.7s.3.7.7.7c.4 0 .7-.3.7-.7s-.4-.7-.7-.7zm-3.1 5.7c-.4 0-.7.3-.7.7 0 .4.3.7.7.7.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7zm-3 2.9c-.2.4-.4.7-.6 1.1.1.1.3.2.5.2.4 0 .7-.3.7-.7 0-.3-.3-.6-.6-.6zm9.2-18.8c.2 0 .4-.1.5-.2-.2-.4-.4-.7-.6-1.1-.3.1-.5.3-.5.6-.1.4.2.7.6.7zm3 5.8c.3 0 .5-.1.6-.4-.2-.3-.3-.6-.5-1h-.1c-.4 0-.7.3-.7.7.1.4.4.7.7.7zm-9.2 7.2c-.1 0-.3.1-.4.1l-.3.6c0 .3.3.6.6.6.4 0 .7-.3.7-.7s-.2-.6-.6-.6zm12.3-1.5c.1 0 .2 0 .4-.1-.2-.4-.3-.8-.5-1.2-.3.1-.5.3-.5.6 0 .4.3.7.6.7zm-12.3 7.3c-.4 0-.7.3-.7.7 0 .3.2.5.4.6.2-.1.4-.1.6-.2.1 0 .2-.1.2-.1.1-.1.1-.2.1-.4.1-.3-.2-.6-.6-.6zm6.2-11.5c-.4 0-.7.3-.7.7 0 .4.3.7.7.7.4 0 .7-.3.7-.7-.1-.4-.4-.7-.7-.7zm3 5.7c-.4 0-.7.3-.7.7s.3.7.7.7c.4 0 .7-.3.7-.7s-.3-.7-.7-.7zm0 2.9c-.4 0-.7.3-.7.7v.2c.4-.2.8-.3 1.2-.5.1-.2-.2-.4-.5-.4zm0-5.7c-.4 0-.7.3-.7.7s.3.7.7.7c.4 0 .7-.3.7-.7s-.3-.7-.7-.7zm-3-8.6c-.4 0-.7.3-.7.7 0 .4.3.7.7.7.4 0 .7-.3.7-.7-.1-.5-.4-.7-.7-.7zm6.1 11.4c-.4 0-.7.3-.7.7s.3.7.7.7c.4 0 .7-.3.7-.7s-.3-.7-.7-.7zm-3.1-5.7c-.4 0-.7.3-.7.7 0 .4.3.7.7.7.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7zm-3-2.9c-.4 0-.7.3-.7.7 0 .4.3.7.7.7.4 0 .7-.3.7-.7-.1-.4-.4-.7-.7-.7zm-2.7-1.7c.2-.1.3-.3.3-.5v-.2c-.2.2-.3.5-.3.7zm2.7 13.2c-.4 0-.7.3-.7.7 0 .4.3.7.7.7.4 0 .7-.3.7-.7-.1-.4-.4-.7-.7-.7zm-3.1-11.5h-.2c-.1.3-.2.7-.3 1 .1.2.3.3.5.3.4 0 .7-.3.7-.7-.1-.3-.4-.6-.7-.6zm3.1 5.8c-.4 0-.7.3-.7.7s.3.7.7.7c.4 0 .7-.3.7-.7s-.4-.7-.7-.7zm0 2.8c-.4 0-.7.3-.7.7s.3.7.7.7c.4 0 .7-.3.7-.7s-.4-.7-.7-.7zM96.8 276.8c-.3-.2-.6-.2-.9 0-.3.3-.3.7 0 .9s.7.3.9 0c.2-.2.2-.6 0-.9.1.1.1.1 0 0zm-1 4.3c-.3.3-.3.7 0 .9.3.3.7.3.9 0 .3-.3.3-.7 0-.9s-.6-.3-.9 0zm-.1 4.2c-.3.3-.3.7 0 .9s.7.3.9 0 .3-.7 0-.9c-.3-.3-.7-.3-.9 0zm3 2.1c-.1 0-.1-.1 0 0-.3-.3-.7-.3-1-.1-.3.3-.3.7 0 .9h.1v.1c.3.3.7.3.9 0 .3-.2.3-.6 0-.9zm-1.1 4.2c-.3.3-.3.7 0 .9.3.3.7.3.9 0 .3-.3.3-.7 0-.9-.2-.2-.6-.2-.9 0zm-1.1-2c0-.1 0-.1 0 0-.3-.3-.7-.3-1-.1s-.3.7 0 .9h.1v.1c.3.3.7.3.9 0 .3-.2.3-.6 0-.9zm-2.7-10.5c-.3.3-.3.7 0 .9.3.3.7.3.9 0 .3-.3.3-.7 0-.9-.2-.3-.7-.3-.9 0zm-.2 4.2c-.1.1-.1.2-.2.3v.4c0 .1.1.2.1.2.3.3.7.3.9 0s.3-.7 0-.9c-.1-.3-.5-.3-.8 0zm0 4.1c0 .4 0 .8.1 1.2.2.1.5 0 .7-.1.3-.3.3-.7 0-.9-.2-.3-.5-.4-.8-.2zm.7 4.3c-.1 0-.1 0 0 0-.1-.1-.2-.2-.3-.2 0 .4.1.9.1 1.3.1 0 .2-.1.2-.1.3-.2.3-.7 0-1 0 .1 0 0 0 0zm1 2c.3.1.6 0 .9 0-.2-.3-.6-.3-.9 0zm-.6-18.9c-.3-.2-.6-.1-.8.1-.3.3-.3.7 0 .9.3.3.7.3.9 0 .2-.2.2-.6.1-.8 0-.1-.1-.2-.2-.2zm3.1 8.3c-.3.3-.3.7 0 .9s.7.3.9 0 .3-.7 0-.9c-.2-.2-.6-.2-.9 0zm10.4 6c-.3.3-.3.7 0 .9.3.3.7.3.9 0 .3-.3.3-.7 0-.9-.2-.2-.6-.2-.9 0zm-2-2c-.3.3-.3.7 0 .9s.7.3.9 0 .3-.7 0-.9c-.2-.2-.7-.2-.9 0zm-.2 4.2c-.3.3-.3.7 0 .9.3.3.7.3.9 0 .3-.3.3-.7 0-.9s-.6-.2-.9 0zm-1.8-6.2c-.3.3-.3.7 0 .9.3.3.7.3.9 0 .3-.3.3-.7 0-.9s-.7-.3-.9 0zm6 6.1c-.2.2-.2.5-.1.7.4-.1.8-.2 1.3-.3 0-.2-.1-.3-.2-.5-.3-.2-.7-.2-1 .1zm-6.2-1.9c-.3.3-.3.7 0 .9s.7.3.9 0 .3-.7 0-.9c-.2-.3-.6-.3-.9 0zm-6-10.4c-.3.3-.3.7 0 .9.3.3.7.3.9 0 .3-.3.3-.7 0-.9s-.7-.3-.9 0zm14.3 10.7c0 .1.1.2.2.3.1.1.3.2.5.2-.3-.2-.5-.3-.7-.5zm-12.3-8.7c-.3.3-.3.7 0 .9s.7.3.9 0c.3-.3.3-.7 0-.9-.2-.2-.6-.2-.9 0zm.8 4.3c-.3-.3-.7-.3-1-.1s-.3.7 0 .9h.1v.1c.3.3.7.3.9 0 .4-.2.4-.6 0-.9.1 0 .1 0 0 0zm-1 4.2c-.3.3-.3.7 0 .9s.7.3.9 0 .3-.7 0-.9c-.2-.2-.6-.2-.9 0zm2.2-2.1c-.3.3-.3.7 0 .9.3.3.7.3.9 0 .3-.3.3-.7 0-.9-.2-.3-.7-.3-.9 0zm-.2 4.2c-.3.3-.3.7 0 .9.3.3.7.3.9 0 .3-.3.3-.7 0-.9-.2-.3-.6-.3-.9 0zm1.2-8.5c-.3-.3-.7-.3-1-.1-.3.3-.3.7 0 .9h.1v.1c.3.3.7.3.9 0s.3-.6 0-.9c.1 0 0 0 0 0zM194.4 6.1c-.3.2-.5.5-.8.7 0 .3.3.6.6.6.4 0 .7-.3.7-.7.1-.3-.2-.5-.5-.6zm-.1 2.8c-.4 0-.7.3-.7.7s.3.7.7.7c.4 0 .7-.3.7-.7s-.3-.7-.7-.7zm0 5.8c-.3 0-.5.2-.6.4.4 0 .8 0 1.2.1-.1-.3-.3-.5-.6-.5zm0-2.9c-.4 0-.7.3-.7.7s.3.7.7.7c.4 0 .7-.3.7-.7s-.3-.7-.7-.7zm3.1 2.9c-.3 0-.6.2-.6.6.4 0 .9.1 1.3.1-.1-.4-.4-.7-.7-.7zm0-8.6c-.4 0-.7.3-.7.7 0 .4.3.7.7.7.4 0 .7-.3.7-.7-.1-.4-.4-.7-.7-.7zm.3-2.8c-.1.1-.2.2-.4.3-.2.2-.4.3-.5.5.1.3.3.5.6.5.4 0 .7-.3.7-.7-.1-.3-.2-.5-.4-.6zm-.3 5.6c-.4 0-.7.3-.7.7s.3.7.7.7c.4 0 .7-.3.7-.7s-.4-.7-.7-.7zm0 2.9c-.4 0-.7.3-.7.7s.3.7.7.7c.4 0 .7-.3.7-.7s-.4-.7-.7-.7zm-12 3c.1 0 0 0 0 0zm2.3 0h.9c-.1-.1-.3-.2-.5-.2-.1.1-.3.1-.4.2zm18.9-7.4c.3 0 .6-.3.6-.6-.2-.2-.4-.5-.6-.7h-.1c-.4 0-.7.3-.7.7.2.3.5.6.8.6zm3.1 2.9h.2c-.2-.3-.5-.6-.7-1-.1.1-.1.2-.1.3-.1.4.2.7.6.7zm-21.3 1.5l-.8.8c.1.2.3.4.6.4.4 0 .7-.3.7-.7-.1-.1-.3-.4-.5-.5zm2.8 0c-.4 0-.7.3-.7.7s.3.7.7.7c.4 0 .7-.3.7-.7s-.3-.7-.7-.7zm.2-2.8c-.3.2-.5.5-.8.7.1.3.3.6.6.6.4 0 .7-.3.7-.7 0-.3-.2-.6-.5-.6zm-.7 5.9h1c-.1-.2-.3-.3-.5-.3-.2.1-.4.2-.5.3zm15.9-6c-.4 0-.7.3-.7.7s.3.7.7.7c.4 0 .7-.3.7-.7s-.3-.7-.7-.7zm0 5.8c-.4 0-.7.3-.7.7s.3.7.7.7c.4 0 .7-.3.7-.7s-.3-.7-.7-.7zm-3.1-11.5c-.4 0-.7.3-.7.7 0 .4.3.7.7.7.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7zm0 5.7c-.4 0-.7.3-.7.7s.3.7.7.7c.4 0 .7-.3.7-.7s-.3-.7-.7-.7zm0-2.8c-.4 0-.7.3-.7.7 0 .4.3.7.7.7.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7zm3.1 5.7c-.4 0-.7.3-.7.7s.3.7.7.7c.4 0 .7-.3.7-.7s-.3-.7-.7-.7zm3.1 2.9c-.4 0-.7.3-.7.7s.3.7.7.7c.4 0 .7-.3.7-.7s-.3-.7-.7-.7zm3.6.3l-.1-.1c-.1-.1-.3-.2-.5-.2-.4 0-.7.3-.7.7s.3.7.7.7c.4 0 .7-.3.7-.7 0-.2 0-.3-.1-.4zm-12.8-.3c-.4 0-.7.3-.7.7v.1c.4 0 .8.1 1.2.1 0-.1.1-.2.1-.2 0-.4-.3-.7-.6-.7zm9.2-2.9c-.4 0-.7.3-.7.7s.3.7.7.7c.4 0 .7-.3.7-.7s-.3-.7-.7-.7zm-9.2-5.7c-.4 0-.7.3-.7.7 0 .4.3.7.7.7.4 0 .7-.3.7-.7-.1-.4-.4-.7-.7-.7zm0 2.8c-.4 0-.7.3-.7.7s.3.7.7.7c.4 0 .7-.3.7-.7s-.4-.7-.7-.7zm0 2.9c-.4 0-.7.3-.7.7s.3.7.7.7c.4 0 .7-.3.7-.7s-.4-.7-.7-.7zm3 0c-.4 0-.7.3-.7.7s.3.7.7.7c.4 0 .7-.3.7-.7s-.3-.7-.7-.7zm0 2.9c-.4 0-.7.3-.7.7 0 .2.1.3.2.4.3 0 .6.1.9.1.2-.1.3-.3.3-.5 0-.4-.3-.7-.7-.7zm-3.6-13.3c.1.2.3.3.5.3.4 0 .7-.3.7-.7 0-.2-.1-.3-.2-.4-.3.2-.6.5-1 .8zm.6 1.8c-.4 0-.7.3-.7.7 0 .4.3.7.7.7.4 0 .7-.3.7-.7-.1-.4-.4-.7-.7-.7z"
        className="st5"
      />
    </svg>
  );
}

export default CivicHeaderImage;
